import SocialCredential from "./base";

const FtpCredential = SocialCredential.extend({
    parse: function (response) {
        response = FtpCredential.__super__.parse.apply(this, arguments);

        response.name = response.ftpIntegrationName;
        response.typeLabel = `FTP`;
        response.platformType = `FTP account`;
        response.profileImage = response.ftpProfileImageUrl;

        return response;
    }
});

export default FtpCredential;
